import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { LabelColumn, Row, ValueColumn } from "src/components/shared/Sidebar/SidebarTable";
import { localizeCurrencyToWholeNumber } from "src/utils";

const MSRPWithPrice = styled("span")<{ showStrikethrough: boolean }>`
    text-decoration: ${(props) => (props.showStrikethrough ? "line-through" : "none")};
    color: ${(props) => props.theme.palette.grey[20]};
    font-size: 13px;
    font-weight: normal;
`;

interface Props {
    showMsrp: boolean;
    msrp: number;
    price: number;
    showStrikethroughForMSRP: boolean;
}

const Msrp = ({ showMsrp, msrp, price, showStrikethroughForMSRP }: Props) => {
    const { t } = useTranslation();

    if (!showMsrp || !msrp) {
        return null;
    }

    return (
        <Row>
            <LabelColumn>{t("ContinueDeal.VehicleInfo.msrpLabel")}</LabelColumn>
            <ValueColumn>
                {msrp === price ? (
                    <span>{localizeCurrencyToWholeNumber(msrp)}</span>
                ) : (
                    <MSRPWithPrice showStrikethrough={showStrikethroughForMSRP}>
                        {localizeCurrencyToWholeNumber(msrp)}
                    </MSRPWithPrice>
                )}
            </ValueColumn>
        </Row>
    );
};

export default Msrp;
